import * as customTheme from './theme';

export { default as authProvider } from './authProvider';
export { default as apiDocumentationParser } from './apiDocumentationParser';
export { default as dataProvider } from './dataProvider';
export { default as i18nProvider } from './i18n';
export const theme = customTheme;